import React from 'react';

const DisclaimerSecurity: React.FC = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold mb-6">Disclaimer & Data Security</h1>

        <h2 className="text-xl font-semibold mt-6 mb-2">Disclaimer</h2>
        <p className="mb-4">CosmaComply is a compliance management tool. We do not provide legal advice and the software does not automatically ensure compliance. We are not affiliated with or endorsed by the FDA. Customers remain solely responsible for the accuracy of their data and for the submission of required information to the FDA.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Data Security Statement</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Encrypted storage of sensitive data.</li>
          <li>Passwords secured with industry-standard hashing (bcrypt).</li>
          <li>Regular backups to prevent loss.</li>
          <li>Access controlled by role-based permissions.</li>
          <li>No sensitive data stored in browser cache or plain logs.</li>
          <li>Adverse events retained for 6 years (MoCRA).</li>
        </ul>

        <p className="mt-6">Questions? <a href="mailto:cosmacomply@gmail.com" className="text-indigo-600 hover:underline">cosmacomply@gmail.com</a></p>
      </div>
    </div>
  );
};

export default DisclaimerSecurity;


